/**
 * Payment Assignment "work queue roles".
 *
 * IMPORTANT:
 * - These are NOT the same as platform auth roles from `@hixme/role-policy`.
 * - Real users will have platform roles like `ROLE_PLATFORM_HIXME_ADMIN` (value
 *   is typically something like "PlatformHixmeAdmin").
 * - The Maker/Checker/Escalator assignment role is determined by a backend
 *   endpoint (by userId).
 *
 * These constants are used for:
 * - dev-only "View as" role switcher
 * - interpreting the "payment-assignment role" API response
 */

export enum PaymentAssignmentRole {
  MAKER = 'MAKER',
  CHECKER = 'CHECKER',
  ESCALATOR = 'ESCALATOR',
  UNKNOWN = 'Unknown',
}

export function normalizePaymentAssignmentRole(
  value?: string | null
): PaymentAssignmentRole {
  if (value === PaymentAssignmentRole.MAKER) return PaymentAssignmentRole.MAKER
  if (value === PaymentAssignmentRole.CHECKER)
    return PaymentAssignmentRole.CHECKER
  if (value === PaymentAssignmentRole.ESCALATOR)
    return PaymentAssignmentRole.ESCALATOR
  return PaymentAssignmentRole.UNKNOWN
}
